import { createAction } from '@reduxjs/toolkit';

import {
  EDITING_DOCUMENT__COMPLETE_EDIT,
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_DATA_SET,
  EDITING_DOCUMENT__FIELD_DELETE,
  EDITING_DOCUMENT__FIELD_POSITION_CHANGE,
  EDITING_DOCUMENT__FIELD_SIZE_CHANGE,
  EDITING_DOCUMENT__FIELD_TARGET_DATA_SET,
  EDITING_DOCUMENT__FIELD_TARGET_SET,
  EDITING_DOCUMENT__FILE_LOAD_FAILURE,
  EDITING_DOCUMENT__FILE_LOAD_REQUEST,
  EDITING_DOCUMENT__FILE_LOAD_SUCCESS,
  EDITING_DOCUMENT__SET_IS_NEW_EDITING_DOCUMENT,
  EDITING_DOCUMENT__SUBMIT_FAILURE,
  EDITING_DOCUMENT__SUBMIT_REQUEST,
  EDITING_DOCUMENT__SUBMIT_SUCCESS,
  EDITING_DOCUMENT__TEXT_FIELD_CONTEXT_MENU_CHANGE,
} from '@app/store/actionTypes';
import EditingDocumentField from '@app/store/editingDocument/EditingDocumentField';
import EditingDocumentFieldTarget from '@app/store/editingDocument/EditingDocumentFieldTarget';
import EditingDocumentInput from '@app/store/editingDocument/EditingDocumentInput';
import EditingDocumentSignatureFieldType from '@app/store/editingDocument/EditingDocumentSignatureFieldType';
import TextFieldChangeType from '@app/store/editingDocument/TextFieldChangeType';
import FieldType from '@app/store/FieldType';

export function editingDocumentFieldDataSet(payload: {
  page: number;
  relativeX: number;
  relativeY: number;
}) {
  return {
    type: EDITING_DOCUMENT__FIELD_DATA_SET,
    payload,
  };
}

export function editingDocumentFieldCreate(payload: EditingDocumentField) {
  return {
    type: EDITING_DOCUMENT__FIELD_CREATE,
    payload,
  };
}

export function editingDocumentFieldDelete(uuid: string, page: number) {
  return {
    type: EDITING_DOCUMENT__FIELD_DELETE,
    payload: { page, uuid },
  };
}

export function editingDocumentSubmitRequest(payload: {
  id: string;
  inputs: EditingDocumentInput[];
}) {
  return {
    type: EDITING_DOCUMENT__SUBMIT_REQUEST,
    payload,
  };
}

export const editingDocumentSubmitSuccess = createAction(EDITING_DOCUMENT__SUBMIT_SUCCESS);

export function editingDocumentSubmitFailure(payload: { isTimeout: boolean }) {
  return {
    type: EDITING_DOCUMENT__SUBMIT_FAILURE,
    payload,
    error: true,
  };
}

export function editingDocumentCompleteEdit() {
  return {
    type: EDITING_DOCUMENT__COMPLETE_EDIT,
  };
}

export function editingDocumentFieldPositionChange(
  uuid: string,
  relativeX: number,
  relativeY: number
) {
  return {
    type: EDITING_DOCUMENT__FIELD_POSITION_CHANGE,
    payload: { relativeX, relativeY, uuid },
  };
}

export function editingDocumentFieldTargetDataSet(payload: {
  fieldType?: FieldType;
  id?: string | number;
  s3Key?: string;
  // TODO: (@domuk-k ) 문편기 필드의 type 수정 필요 - 상위 타입(필드타입)과 하위 타입(필드 타입 중 서명필드에 속하는 6가지 서명타입)이 함께 쓰이고 있음
  type: FieldType | EditingDocumentSignatureFieldType;
  url?: string;
  uuid: string;
}) {
  return {
    type: EDITING_DOCUMENT__FIELD_TARGET_DATA_SET,
    payload,
  };
}

export function editingDocumentFieldTargetSet(payload: EditingDocumentFieldTarget) {
  return {
    type: EDITING_DOCUMENT__FIELD_TARGET_SET,
    payload,
  };
}

export function editingDocumentLoadFile(payload: string) {
  return {
    type: EDITING_DOCUMENT__FILE_LOAD_REQUEST,
    payload,
  };
}

export function editingDocumentLoadFileSuccess(payload: string) {
  return {
    type: EDITING_DOCUMENT__FILE_LOAD_SUCCESS,
    payload,
  };
}

export function editingDocumentLoadFileFailure(payload: Error) {
  return {
    type: EDITING_DOCUMENT__FILE_LOAD_FAILURE,
    payload,
    error: true,
  };
}

export function editingDocumentFieldSizeChange(
  uuid: string,
  relativeHeight: number,
  relativeWidth: number,
  currentScaleHeight: number,
  currentScaleWidth: number
) {
  return {
    type: EDITING_DOCUMENT__FIELD_SIZE_CHANGE,
    payload: {
      currentScaleHeight,
      currentScaleWidth,
      relativeHeight,
      relativeWidth,
      uuid,
    },
  };
}

export function editingDocumentTextFieldContextMenuChange(
  inputId: string,
  changedType: TextFieldChangeType,
  value: string | number
) {
  return {
    type: EDITING_DOCUMENT__TEXT_FIELD_CONTEXT_MENU_CHANGE,
    payload: { inputId, changedType, value },
  };
}

export function editingDocumentSetIsNewEditingDocument() {
  return {
    type: EDITING_DOCUMENT__SET_IS_NEW_EDITING_DOCUMENT,
  };
}

export type EditingDocumentAction =
  | ReturnType<typeof editingDocumentFieldDataSet>
  | ReturnType<typeof editingDocumentFieldCreate>
  | ReturnType<typeof editingDocumentFieldDelete>
  | ReturnType<typeof editingDocumentSubmitRequest>
  | ReturnType<typeof editingDocumentSubmitSuccess>
  | ReturnType<typeof editingDocumentSubmitFailure>
  | ReturnType<typeof editingDocumentCompleteEdit>
  | ReturnType<typeof editingDocumentFieldPositionChange>
  | ReturnType<typeof editingDocumentFieldTargetDataSet>
  | ReturnType<typeof editingDocumentFieldTargetSet>
  | ReturnType<typeof editingDocumentLoadFile>
  | ReturnType<typeof editingDocumentLoadFileSuccess>
  | ReturnType<typeof editingDocumentLoadFileFailure>
  | ReturnType<typeof editingDocumentFieldSizeChange>
  | ReturnType<typeof editingDocumentTextFieldContextMenuChange>
  | ReturnType<typeof editingDocumentSetIsNewEditingDocument>;
